<template>

    <div class="creditcard-wrapper d-flex flex-column align-items-center">
      <form id="payment-form" class="w-75 d-flex flex-column align-items-center" >
        <div ref="card" class="form-control m-2">
          <!-- A Stripe Element will be inserted here. -->
        </div>
      </form>
    </div>

</template>

<script>

export default{
  data () {
    return {
      spk: 'pk_live_51LB2QBBF095vBbQ4NbNY3jxHCDJMy4k27iRRZfmb3EZJO4OAoY58K3fD57zt8inkAillLByDuWg6FJLOJWQUgrQT00Nctw8t3c',  //'pk_test_51IAoMNCfqObecRJifTE6VBysHMQ9pARgiOI4ei1NUE9eT0XdWZwQaCIdKeuAWpWpobz2jtn2JeYamwebqa6bNInh00SSz0DwyF',
      stripe:undefined,
      card:undefined,
      msg: 'Credit Card',
      payAmount:this.info.payAmount,
      lockSubmit:false,
      elements: null,
      api:'https://restapi.authorizelocal.com/api'
    }
  },
  props: {
    info: {
      type: Object,
      required: true
    },
    pi_secret: {
      type: String,
      required: true
    },
    seti: {
      type: String,
      required: false
    }
  },
  computed: {
  },
  methods: {
    purchase (callback) {
      const self = this
      self.lockSubmit = true
      self.stripe.confirmPayment({
        elements: self.elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: 'https://portal.authorizelocal.com/checkout'
        }
      }).then(function (result) {
        if (result.error) {

          self.$vs.notify({
            title: 'Error',
            text: result.error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          self.$forceUpdate() // Forcing the DOM to update so the Stripe Element can update.
          self.lockSubmit = false
          callback(result)
        } else {
          callback(result)
        }
      }).catch((err) => {
        self.$vs.notify({
          title: 'Error',
          text: err.message,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        self.lockSubmit = false
        callback(err)
      })
    },
    setup (callback) {
      const self = this
      self.lockSubmit = true
      self.stripe.confirmSetup({
        elements: self.elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: 'https://portal.authorizelocal.com/checkout'
        }
      }).then(function (result) {
        if (result.error) {

          self.$vs.notify({
            title: 'Error',
            text: result.error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          self.$forceUpdate() // Forcing the DOM to update so the Stripe Element can update.
          self.lockSubmit = false
          callback(result)
        } else {
          callback(result)
        }
      }).catch((err) => {
        self.$vs.notify({
          title: 'Error',
          text: err.message,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        self.lockSubmit = false
        callback(err)
      })
    },
    processTransaction (transactionToken, callback) {
      const self = this
      const dt = {
        amount: self.payAmount,
        stripeToken: transactionToken
      }
      callback(dt)
    },
    async getPaymentIntent () {
      const appearance = {
        theme: 'flat'
      }
      const clientSecret = this.pi_secret
      const strOptions = {
        clientSecret,
        appearance
      }

      const self = this
      self.elements = self.stripe.elements(strOptions)
      self.card = self.elements.create('payment')
      self.card.mount(self.$refs.card)
    }
  },
  mounted () {
    const self = this
    self.stripe = window.Stripe(self.spk)
    this.getPaymentIntent()
    console.log(self.info)
  }
}
</script>

<style lang="scss" scoped>
  .creditcard-wrapper {
    padding: 0 0 20px 0;
    form {
      text-align: right;
    }
  }
</style>
